module.exports = __webpack_public_path__ + "static/media/llamadaInactivo.3c930429.svg";